import { Container } from "@mui/material";
import React from "react";
import BannerSection from "../component/Home/BannerSection";
import ReviewCardSection from "../component/Home/ReviewSection";
import StreamLine from "../component/Home/StreamLine";

const Home = () => {
  return (
    <Container
      maxWidth="xl"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems:"center"
      }}
    >
      <BannerSection />
      <StreamLine/>
      <ReviewCardSection />
    </Container>
  );
};

export default Home;
